import { setSnack, SnackCategories } from '4ff-lib-foundation/lib/AppFrame/publicAPI/notifications';

const errorSnack = options => setSnack({
  ...options,
  text: options.text,
  category: SnackCategories.ERROR,
});

const warnSnack = options => setSnack({
  ...options,
  text: options.text,
  category: SnackCategories.WARNING,
});

export {
  errorSnack,
  warnSnack,
};
